var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_809_3245",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_809_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.952 8.9135V16.0865L11.548 12.5L7.952 8.9135ZM5.30775 21C4.80908 21 4.38308 20.8234 4.02975 20.4703C3.67658 20.1169 3.5 19.6909 3.5 19.1923V5.80775C3.5 5.30908 3.67658 4.88308 4.02975 4.52975C4.38308 4.17658 4.80908 4 5.30775 4H18.6923C19.1909 4 19.6169 4.17658 19.9703 4.52975C20.3234 4.88308 20.5 5.30908 20.5 5.80775V19.1923C20.5 19.6909 20.3234 20.1169 19.9703 20.4703C19.6169 20.8234 19.1909 21 18.6923 21H5.30775ZM16 19.5H19V5.80775C19 5.73075 18.9679 5.66025 18.9038 5.59625C18.8398 5.53208 18.7692 5.5 18.6923 5.5H16V19.5ZM14.5 19.5V5.5H5.30775C5.23075 5.5 5.16025 5.53208 5.09625 5.59625C5.03208 5.66025 5 5.73075 5 5.80775V19.1923C5 19.2692 5.03208 19.3398 5.09625 19.4038C5.16025 19.4679 5.23075 19.5 5.30775 19.5H14.5Z",
    fill: "#00426F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideRight);
export default __webpack_public_path__ + "static/media/sideRight.de9d6bcd18f2518367e1958dbcfb9cfe.svg";
export { ForwardRef as ReactComponent };